export default __webpack_public_path__ + "static/media/New Capital.11f6e5cc.svg";